// Event listeners
var scroller = 0;
var scrollElement = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body);
function updateScroller() {
    scroller = $(window).scrollTop();
}

window.addEventListener('scroll', function(e) {
    updateScroller();
    stickyTopBar.checkDistance();
});

window.addEventListener('resize', function() {stickyTopBar.refreshDistance();}, true);

var stickyTopBar = {
    topBar: document.getElementById("sticky-navbar"),
    anchor: document.getElementById("stick-after"),
    fixedTopBar: null,
    distance: 0,
    sticked: false,
    startAfter: false,
    started: false,

    getDistance: function(element) {
        var yPos = this.startAfter ? this.anchor.offsetHeight : 0;

        while(element) {
            yPos += (element.offsetTop);
            element = element.offsetParent;
        }

        return yPos;
    },

    checkDistance: function() {
        if(!this.started) return;
        (scroller >= this.distance) && (!this.sticked) ? this.stickIt() : null;
        (scroller < this.distance) && (this.sticked) ? this.unstickIt() : null;
    },

    stickIt: function() {
        this.sticked = true;
        this.topBar.classList.toggle("header__navbar--sticked");
    },

    unstickIt: function() {
        this.sticked = false;
        this.topBar.classList.toggle("header__navbar--sticked");
    },

    refreshDistance: function() {
        this.distance = this.getDistance(this.anchor);
    },

    init: function() {
        this.startAfter = true;
        this.started = true;
        this.refreshDistance();
        this.checkDistance();

    }
};

window.addEventListener('load', function() {
    updateScroller();
    stickyTopBar.init();
});